import { render, staticRenderFns } from "./AverageTreatmentByArea.vue?vue&type=template&id=c9717c7a&"
import script from "./AverageTreatmentByArea.vue?vue&type=script&lang=js&"
export * from "./AverageTreatmentByArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports